import { render, staticRenderFns } from "./Bonusreceive.vue?vue&type=template&id=420fc609&scoped=true"
import script from "./Bonusreceive.vue?vue&type=script&lang=js"
export * from "./Bonusreceive.vue?vue&type=script&lang=js"
import style0 from "./Bonusreceive.vue?vue&type=style&index=0&id=420fc609&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420fc609",
  null
  
)

export default component.exports